import { useQuery } from '@tanstack/react-query';

import { getUnfinishedRoutesMutationKey } from '.';
import { routeService } from '../../../../application/RouteService';
import { useErrorMiddleware } from '../../../../hooks/useErrorMiddleware';
import { useShowSnackbarMessage } from '../../../../hooks/useShowSnackbarMessage';

// Hook to retrieve the number of old unfinished routes
export const useSearchUnfinishedRoutes = () => {
  const { sessionExpiredLogout } = useErrorMiddleware();
  const { showSnackbarMessage } = useShowSnackbarMessage();
  const { isSuccess, refetch, data, error, isLoading } = useQuery(
    getUnfinishedRoutesMutationKey(),
    () => routeService.searchUnfinishedRoutes(),
    {
      retry: 1,
      enabled: true,
      refetchOnWindowFocus: false,
      onError: (err: any) => {
        console.info(`Retrieve Unfinished Routes Error: `, err?.response);
        if (err?.response?.status === 401) {
          sessionExpiredLogout();
          return;
        }
        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    error: error,
    success: isSuccess,
    isLoading: isLoading,
    data: data,
    run: refetch,
  };
};
